import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import { Grid } from "@mui/material"
import { Campus, ConsentementMultiple, CountryResidence, MentionsLegales, RequiredFields, Submit } from "components"
import { Dropdown, Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { consent, consentement, defaultValues, salutations } from "services"
import schema from "./Validation"
import formations, { getMscQueryParamName } from "../services/formations"
import { academicLevelOptions } from "../services/options"

const Form = () => {
  const { recordTypeId, setError, setOpenSnackbar } = useForms()
  const { submission } = useSubmission()
  const { url } = useUrlReturn("ISTM-DOCUMENTATION")

  const methods = useForm({
    defaultValues: {
      ...consent,
      lead: {
        ...defaultValues,
        ...consentement,
        AcademicLevel__c: "",
        Country: "",
        Salutation: "",
        Wished_Programm__c: ""
      }
    },
    resolver: yupResolver(schema)
  })

  const { control } = methods

  const onSubmit = async (data) => {
    setOpenSnackbar(false)

    if (!recordTypeId) {
      setError("Le formulaire est en cours de chargement, veuillez réessayer.", "RecordTypeId manquant")
      return
    }

    const lead = data.lead
    const defaultDataLead = {
      Campus__c: "Paris",
      Division__c: "IONIS STM",
      IONISSchool__c: "IONIS STM",
      LastForm__c: "Documentation PDF",
      LeadSource: "Internet: Demande de doc",
      RecordTypeId: recordTypeId
    }

    const finalLead = { ...lead, ...defaultDataLead }

    try {
      await submission({
        formId: "DOC",
        lead: finalLead,
        utmCookieName: "_ionis_user_data"
      })

      if (url) {
        const redirectUrl = new URL(url, document.location.origin)
        const mscQueryParamName = getMscQueryParamName(lead.Wished_Programm__c)
        redirectUrl.searchParams.delete("msc")
        if (mscQueryParamName) {
          redirectUrl.searchParams.set(mscQueryParamName, "1")
        }
        document.location.href = redirectUrl.toString()
      }
    } catch (error) {
      setError("Une erreur est survenue lors de la soumission du formulaire", error)
    }
  }

  useSalesforce("Ionis-STM", false)

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber
            control={control}
            name="lead.MobilePhone"
            label="Téléphone"
            required
          />
        </Grid>
        <CountryResidence native />
        <Grid item sm={6} xs={12}>
          <Dropdown control={control} label="Je suis intéressé.e par le MSc" name="lead.Wished_Programm__c" native options={formations} required />
        </Grid>
        <Grid item xs={12}>
          <Dropdown control={control} label="Niveau académique actuel" name="lead.AcademicLevel__c" native options={academicLevelOptions} required />
        </Grid>
        <ConsentementMultiple />
        <RequiredFields />
        <Submit label="Je demande la documentation" onSubmit={onSubmit} />
        <MentionsLegales form="Documentation" school="IONIS STM" />
      </Grid>
    </FormProvider>
  )
}

export default Form
